// STRING CONSTS

export const str_consts = {};

export const DOT = '.';
export const COMMA = ',';
export const SLASH = '/';
export const MINUS = '-';
export const DOLLAR = '$';
export const SPACE = ' ';

export const TAB_CHARACTER = '\t'; // Unicode Character (U+0009) ISO Name:	<Character Tabulation> (HT, TAB). Formerly:	Character Tabulation
/*
https://symbl.cc/en/0009/
Horizontal Tabulation

The Horizontal Tab symbol was developed to simplify text formatting. It provided a mechanism for automatic alignment in vertical columns on output devices, such as printers and computer terminals.

When it comes to text editors and computer terminals, the Horizontal Tab symbol is typically used to move the cursor to the next fixed tab position. Tabs are pre-defined at equal intervals, such as every 8 characters or any other number set by the user. Horizontal tabs make it easier to align text and structure information in tables.

...

Some formats like TSV use the Tab symbol to divide data. This can be more convenient than using a space or comma, which are pretty common and require special escaping.

...

Escape sequence: \t.

It's one of the eight control symbols, the presence of which is required by POSIX:

...

The symbol “Horizontal Tabulation” is included in the “C0 controls” subblock of the “Basic Latin” block and was approved as part of Unicode version 1.1 in 1993.

Synonyms
HT, TAB.

Technical Information

Unicode Name	Horizontal Tabulation
Unicode Number	U+0009
HTML Code	&#9;
CSS Code	\0009
Plane	0: Basic Multilingual Plane
Unicode Block	Basic Latin
Unicode Subblock	C0 controls
Unicode Version	1.1 (1993)
Keyboard shortcut	^I
Escape sequences	\t

*/

/*
https://en.wikipedia.org/wiki/Control_character
Control character
Non-printable character" redirects here.

In computing and telecommunications, a control character or non-printing character (NPC) is a code point in a character set that does not represent a written character or symbol. They are used as in-band signaling to cause effects other than the addition of a symbol to the text. All other characters are mainly graphic characters, also known as printing characters (or printable characters), except perhaps for "space" characters. In the ASCII standard there are 33 control characters, such as code 7, BEL, which rings a terminal bell.
*/

/*
https://en.wikipedia.org/wiki/POSIX
*/

export const NEW_LINE_RN = '\r\n'; // TODO: odluciti se kasnije da li se koristi ovaj ili \n ili \r\n
export const NEW_LINE_N = '\n'; // TODO: odluciti se kasnije da li se koristi ovaj ili \n ili \r\n
export const NEW_LINE_R = '\r'; // TODO: odluciti se kasnije da li se koristi ovaj ili \n ili \r\n

export const NEW_LINE = NEW_LINE_RN;